import { render, staticRenderFns } from "./SelectStatusShip.vue?vue&type=template&id=e05844be&scoped=true&"
import script from "./SelectStatusShip.vue?vue&type=script&lang=js&"
export * from "./SelectStatusShip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05844be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
